module.exports = __webpack_public_path__ + "f4a96cbe05aa3654e46682e3e955e0f4.svg";